import React, { useEffect, useState } from "react";
import axios from "axios";

const ContactsSkeleton = () => {
  return (
    <div className="w-full px-4 md:px-8 lg:px-16 xl:px-24 py-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="h-8 w-64 bg-gray-300 rounded-lg mx-auto mb-4 animate-pulse"></div>
          <div className="h-4 w-96 bg-gray-300 rounded mx-auto animate-pulse"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[...Array(1)].map((_, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-8 h-80 flex flex-col items-center justify-center text-center border border-gray-200 animate-pulse"
            >
              <div className="w-20 h-20 rounded-full bg-gray-300 mb-6"></div>
              <div className="h-6 w-3/4 bg-gray-300 rounded mb-4"></div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-2"></div>
              <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ContactsSection = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fallbackData = {
    address: "4285 Brogdon Exchange NW\nSuwanee, GA 30024",
    businessHours: {
      mondayToFriday: { open: "9:00 AM", close: "6:00 PM" },
      saturday: { open: "10:00 AM", close: "4:00 PM" },
      sunday: { open: "Closed", close: "Closed" }
    }
  };

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/contactinfo/get-contact`
        );
        if (response.data?.success && response.data?.data) {
          setContactData(response.data.data);
        } else {
          setContactData(fallbackData);
        }
      } catch (error) {
        console.error("Error fetching contact data:", error);
        setContactData(fallbackData);
      } finally {
        setLoading(false);
      }
    };

    fetchContactData();
  }, []);

  if (loading) {
    return <ContactsSkeleton />;
  }

  return (
    <div className="w-full px-4 md:px-8 lg:px-12 py-16 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="">
        {/* Business Hours */}
        <div className="text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Business Hours
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-gray-600">
              <div>
                <h4 className="font-semibold text-gray-900">Monday - Friday</h4>
                <p>
                  {contactData?.businessHours?.mondayToFriday?.open || "9:00 AM"} -{" "}
                  {contactData?.businessHours?.mondayToFriday?.close || "6:00 PM"}
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Saturday</h4>
                <p>
                  {contactData?.businessHours?.saturday?.open || "10:00 AM"} -{" "}
                  {contactData?.businessHours?.saturday?.close || "4:00 PM"}
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Sunday</h4>
                <p>
                  {contactData?.businessHours?.sunday?.open || "Closed"} -{" "}
                  {contactData?.businessHours?.sunday?.close || "Closed"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsSection;




// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import phone_icon from "../../../Assets/Images/Contact/phone_icon.webp";
// import location_icon from "../../../Assets/Images/Contact/location_icon.webp";
// import email_icon from "../../../Assets/Images/Contact/email_icon.webp";

// const ContactsSkeleton = () => {
//   return (
//     <div className="w-full px-4 md:px-8 lg:px-16 xl:px-24 py-16">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-12">
//           <div className="h-8 w-64 bg-gray-300 rounded-lg mx-auto mb-4 animate-pulse"></div>
//           <div className="h-4 w-96 bg-gray-300 rounded mx-auto animate-pulse"></div>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {[...Array(3)].map((_, idx) => (
//             <div
//               key={idx}
//               className="bg-white rounded-2xl p-8 h-80 flex flex-col items-center justify-center text-center border border-gray-200 animate-pulse"
//             >
//               <div className="w-20 h-20 rounded-full bg-gray-300 mb-6"></div>
//               <div className="h-6 w-3/4 bg-gray-300 rounded mb-4"></div>
//               <div className="h-4 w-1/2 bg-gray-300 rounded mb-2"></div>
//               <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// const ContactsSection = () => {
//   const [contactData, setContactData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fallbackData = {
//     no1: "(678) 287-1100",
//     whatsappNo: "(678) 714-7454",
//     email: "info@sports&strike.com",
//     address: "4285 Brogdon Exchange NW\nSuwanee, GA 30024",
//   };

//   useEffect(() => {
//     const fetchContactData = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/contactinfo/get-contact`
//         );
//         if (response.data?.success && response.data?.data) {
//           setContactData(response.data.data);
//         } else {
//           setContactData(fallbackData);
//         }
//       } catch (error) {
//         console.error("Error fetching contact data:", error);
//         setContactData(fallbackData);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchContactData();
//   }, []);

//   if (loading) {
//     return <ContactsSkeleton />;
//   }

//   const addressLines = (contactData?.address || fallbackData.address).split(
//     "\n"
//   );

//   return (
//     <div className="w-full px-4 md:px-8 lg:px-12 py-16 bg-gradient-to-br from-gray-50 to-blue-50">
//       <div className="">
//         {/* Contact Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {/* Address Card */}
//           <div className="group relative">
//             <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl blur-lg opacity-25 group-hover:opacity-50 transition duration-300"></div>
//             <div className="relative bg-white rounded-2xl p-8 h-full flex flex-col items-center text-center border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
//                 <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
//                   <img src={location_icon} alt="location" className="w-6 h-6" />
//                 </div>
//               </div>
//               <h3 className="text-xl font-semibold text-gray-900 mb-4">
//                 Our Location
//               </h3>
//               <div className="text-gray-600 leading-relaxed space-y-1">
//                 {addressLines.map((line, idx) => (
//                   <p key={idx} className="text-lg">
//                     {line}
//                   </p>
//                 ))}
//               </div>
//               <div className="mt-6">
//                 <button
//                   onClick={() =>
//                     window.open(
//                       "https://www.google.com/maps/search/?api=1&query=" +
//                         encodeURIComponent(addressLines.join(" ")),
//                       "_blank"
//                     )
//                   }
//                   className="px-6 py-2 bg-blue-600 text-white rounded-full text-sm font-medium hover:bg-blue-700 transition-colors duration-200 transform hover:scale-105"
//                 >
//                   Get Directions
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Phone Card */}
//           <div className="group relative">
//             <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-600 rounded-2xl blur-lg opacity-25 group-hover:opacity-50 transition duration-300"></div>
//             <div className="relative bg-white rounded-2xl p-8 h-full flex flex-col items-center text-center border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="w-20 h-20 rounded-full bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
//                 <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
//                   <img src={phone_icon} alt="phone" className="w-6 h-6" />
//                 </div>
//               </div>
//               <h3 className="text-xl font-semibold text-gray-900 mb-4">
//                 Call Us
//               </h3>
//               <p className="text-2xl font-bold text-gray-900 mb-2">
//                 {contactData?.no1 || fallbackData.no1}
//               </p>
//               <p className="text-gray-500 text-sm mb-4">Main Line</p>
//               <p className="text-lg font-semibold text-gray-900 mb-2">
//                 +1{contactData?.whatsappNo || fallbackData.whatsappNo}
//               </p>
//               <p className="text-gray-500 text-sm mb-6">WhatsApp</p>
//               <div className="flex gap-3 mt-2">
//                 <button
//                   onClick={() =>
//                     (window.location.href = `tel:${
//                       contactData?.no1 || fallbackData.no1
//                     }`)
//                   }
//                   className="px-6 py-2 bg-green-600 text-white rounded-full text-sm font-medium hover:bg-green-700 transition-colors duration-200 transform hover:scale-105"
//                 >
//                   Call Now
//                 </button>
//                 <button
//                   onClick={() => {
//                     const number = (
//                       contactData?.whatsappNo || fallbackData.whatsappNo
//                     ).replace(/\D/g, "");
//                     const url = `https://api.whatsapp.com/send?phone=1${number}&text=&type=phone_number&app_absent=0`;
//                     window.open(url, "_blank");
//                   }}
//                   className="px-6 py-2 bg-gray-100 text-gray-700 rounded-full text-sm font-medium hover:bg-gray-200 transition-colors duration-200 transform hover:scale-105"
//                 >
//                   WhatsApp
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Email Card */}
//           <div className="group relative">
//             <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-red-600 rounded-2xl blur-lg opacity-25 group-hover:opacity-50 transition duration-300"></div>
//             <div className="relative bg-white rounded-2xl p-8 h-full flex flex-col items-center text-center border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="w-20 h-20 rounded-full bg-gradient-to-r from-orange-500 to-red-500 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
//                 <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
//                   <img src={email_icon} alt="email" className="w-6 h-6" />
//                 </div>
//               </div>
//               <h3 className="text-xl font-semibold text-gray-900 mb-4">
//                 Email Us
//               </h3>
//               <p className="text-lg font-medium text-gray-900 mb-2 break-all">
//                 {contactData?.email || fallbackData.email}
//               </p>
//               <p className="text-gray-500 text-sm mb-6">
//                 We'll respond within 24 hours
//               </p>
//               <div className="mt-4">
//                 <button
//                   onClick={() =>
//                     (window.location.href = `mailto:${
//                       contactData?.email || fallbackData.email
//                     }`)
//                   }
//                   className="px-6 py-2 bg-orange-600 text-white rounded-full text-sm font-medium hover:bg-orange-700 transition-colors duration-200 transform hover:scale-105"
//                 >
//                   Send Email
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Additional Info */}
//         <div className="mt-16 text-center">
//           <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
//             <h3 className="text-2xl font-bold text-gray-900 mb-4">
//               Business Hours
//             </h3>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-gray-600">
//               <div>
//                 <h4 className="font-semibold text-gray-900">Monday - Friday</h4>
//                 <p>
//                   {contactData?.businessHours?.mondayToFriday?.open} -{" "}
//                   {contactData?.businessHours?.mondayToFriday?.close}
//                 </p>
//               </div>
//               <div>
//                 <h4 className="font-semibold text-gray-900">Saturday</h4>
//                 <p>
//                   {contactData?.businessHours?.saturday?.open} -{" "}
//                   {contactData?.businessHours?.saturday?.close}
//                 </p>
//               </div>
//               <div>
//                 <h4 className="font-semibold text-gray-900">Sunday</h4>
//                 <p>
//                   {contactData?.businessHours?.sunday?.open} -{" "}
//                   {contactData?.businessHours?.sunday?.close}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactsSection;